export default "__VITE_ASSET__DgYpOVzu__";